import SlideFrame from './SlideFrame';

interface Flow { t: string; steps: string[] }

interface Props {
  title: string; sub: string;
  flows: Flow[];
}

export default function TestingFlows({ title, sub, flows }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="test-flows">
        {flows.map((flow, i) => (
          <div key={i} className="test-flow">
            <div className="test-flow-t">{flow.t}</div>
            <ol className="test-flow-steps">
              {flow.steps.map((step, j) => (
                <li key={j} className="test-flow-step">{step}</li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
